module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/filter-f91eae94e5388d8cb4b33b8d5996d8e4.png";